import { css, SerializedStyles } from "@emotion/react";

export const flowioSelectCss = (hasError: boolean): SerializedStyles => css`
  .MuiSelect-select {
    border-radius: 25px;
    position: relative;
    background-color: #ffffff;
    font-size: 16px;
    padding: 7px 26px 7px 12px;
    height: 24px;
    transition: border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    border: ${hasError ? "1px solid red" : "1px solid #ced4da"};

    font-family: "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto",
      "Helvetica Neue", "Arial", "sans-serif", "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol";

    &:focus {
      border-radius: 25px;
    }
  }
`;

export const placeholderCss = css`
  opacity: 50%;
`;
